import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, xcss } from '@atlaskit/primitives';

import { ErrorBoundary, Attribution } from '@confluence/error-boundary';

import { CreatorRow } from './CreatorRow';
import { ContributorsRow } from './ContributorsRow';
import { LastUpdatedRow } from './LastUpdatedRow';
import { OwnerSection } from './OwnerSection';

const peopleSectionStyles = xcss({
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
});

const secondaryPeopleStyles = xcss({
	marginTop: 'space.200',
});

export const PeopleSection = () => (
	<ErrorBoundary attribution={Attribution.DISCO}>
		<Stack xcss={peopleSectionStyles}>
			<OwnerSection />
			<Stack xcss={secondaryPeopleStyles}>
				<ContributorsRow />
				<CreatorRow />
				<LastUpdatedRow />
			</Stack>
		</Stack>
	</ErrorBoundary>
);
